module.exports = __webpack_public_path__ + "static/media/arrow-return.df5843b9.svg";